import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './BrewsSection.module.css';
import bannerimage from '../../assets/brews.png';

const BrewsSection = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.section}>

      <div className={styles.bannerWrapper}>
        <img
          src={bannerimage}
          alt="Berli Brewing Co. craft beers"
          className={styles.bannerImage}
        />
        <div className={styles.overlay} />

        <div className={styles.content}>
          <p className={styles.eyebrow}>The Brews</p>
          <h2 className={styles.heading}>
            12 Craft Beers.<br />
            <em>One for every palate.</em>
          </h2>
          <p className={styles.body}>
            Not one token option. Not a compromise. Each beer begins with a question —
            what does this land grow, and what can we make with it? Brewed in small
            batches with hyperlocal ingredients, every pour carries the fingerprints
            of the person who made it.
          </p>
          <button
            className={styles.cta}
            onClick={() => navigate('/brews')}
          >
            Explore the Brews
          </button>
        </div>

      </div>

    </section>
  );
};

export default BrewsSection;